import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { HttpRepositoryService } from '../../core/http-repository.service';
import { UserProfile } from '../user-profile.model';
import { UserProfileService } from '../user-profile.service';
import { AntiForgeryTokenService } from '../../auth/anti-forgery-token.service';
import { MessageDialogComponent } from '../../core/message-dialog/message-dialog.component';
import { MessageType } from '../../core/message-dialog/message-type.enum';
import { SubSink } from 'subsink';

declare var $: any;
declare var Toast: any;

@Component({
  selector: 'user-profile-header',
  templateUrl: './user-profile-header.component.html',
  styleUrls: ['./user-profile-header.component.css']
})

export class UserProfileHeaderComponent implements OnInit, OnDestroy {
  private dispUploadErr: any;
  private isUploaded: boolean = false;
  private modalId: string;
  private subs = new SubSink();

  @Input() private user: UserProfile
  @ViewChild('changeHeaderMsg', { static: false }) msgDialog: MessageDialogComponent;

  constructor(private repository: HttpRepositoryService, private userService: UserProfileService, private antiForgery: AntiForgeryTokenService) { }

  ngOnInit() {
    this.modalId = 'changeHeaderMsg';
    this.dispUploadErr = $("#uploadErr");
  }

  private upload(event: any) {
    let that = this;
    const target: DataTransfer = <DataTransfer>(event.target);
    const reader = new FileReader();

    let file = target.files[0];

    if (file) {
      let fileType = /image.*/;

      if (file.type.match(fileType)) {
        reader.onload = function (e: any) {
          that.user.image = reader.result.toString();

          that.isUploaded = true;

          if (that.dispUploadErr.children().length > 0)
            that.dispUploadErr.empty();
        }

        reader.readAsDataURL(file);
      } else {
        if (this.isUploaded)
          this.isUploaded = false;

        this.dispUploadErr.html('<div class="alert-info w-100 text-center">File is not a valid image</div>');
      }
    }
  }

  private editProfileImg() {
    this.msgDialog.show('Are you sure you change user picture?', MessageType.YESNO, 'Update user picture!', () => {

      this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
        if (afResp.hasErrors) {
          Toast.Show(afResp.error, 'Image upload failed.', 'error');
        } else {
          this.subs.sink = this.repository.put<UserProfile>('api/User/EditUserImg', this.user, afResp.data).subscribe(resp => {
            if (resp.hasErrors) {
              Toast.Show(resp.error, 'Image upload failed.', 'error');
            } else {
              Toast.Show('Profile image succsessfully changed', 'User profile', 'success');
              this.changeUserProfileImg(resp.data.image);
              this.isUploaded = false; // reset btn
            }
          });
        }
      });
    });
  }

  private changeUserProfileImg(img: string) {
    this.userService.changeUserImg(img);
  }

  private reset() {
    this.isUploaded = false;
    this.dispUploadErr.empty();
    this.user.image = null;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
